import React, { useEffect, useState } from 'react';
import { HomePage } from './pages/HomePage';
import { ImpactPage } from './pages/ImpactPage';
import { ActivityDetailPage } from './pages/ActivityDetailPage';
import { ActivityPage } from './pages/ActivityPage';
import { ShopPage } from './pages/ShopPage';
import { RewardDetailPage } from './pages/RewardDetailPage';
import { SettingsPage } from './pages/SettingsPage';
import { LoginPage } from './pages/LoginPage';
import { SignUpPage } from './pages/SignUpPage';
import { OnboardingPage } from './pages/OnboardingPage';
import { GBIntelligencePage } from './pages/GBIntelligencePage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { AppProvider, useApp } from './context/AppContext';
import { Toast } from './components/Toast';
interface Activity {
  id: string;
  emoji: string;
  title: string;
  points: number;
  type: 'gold' | 'diamond';
  difficulty: 'Easy' | 'Medium' | 'Hard';
  time: string;
  description?: string;
  instructions?: string[];
  impact?: string;
  completionRate?: number;
}
function AppContent() {
  const [currentPage, setCurrentPage] = useState('login');
  const [previousPage, setPreviousPage] = useState('home');
  const [selectedActivity, setSelectedActivity] = useState<Activity | null>(null);
  const [selectedActionForCert, setSelectedActionForCert] = useState<string | null>(null);
  const [selectedRewardId, setSelectedRewardId] = useState<string | null>(null);
  const [actionsDefaultTab, setActionsDefaultTab] = useState<'planned' | 'unplanned' | 'recent'>('planned');
  const {
    toast,
    hideToast
  } = useApp();
  // Set document title
  useEffect(() => {
    document.title = 'Greenback App';
  }, []);
  const handleNavigate = (page: string, activityOrActionId?: Activity | string) => {
    setPreviousPage(currentPage);
    setCurrentPage(page);
    if (page === 'actions' && activityOrActionId === 'recent-tab') {
      setActionsDefaultTab('recent');
    } else if (page === 'actions' && typeof activityOrActionId === 'string') {
      setActionsDefaultTab('planned');
      setSelectedActionForCert(activityOrActionId);
    } else if (activityOrActionId && typeof activityOrActionId === 'object') {
      setSelectedActivity(activityOrActionId);
    }
  };
  const handleBackFromDetail = () => {
    setCurrentPage('impact');
    setSelectedActivity(null);
  };
  const handleConsumedActionIdToOpen = () => {
    setSelectedActionForCert(null);
  };
  const handleOpenRewardDetail = (rewardId: string) => {
    setSelectedRewardId(rewardId);
    setCurrentPage('reward-detail');
  };
  const renderPage = () => {
    switch (currentPage) {
      case 'login':
        return <LoginPage onNavigate={setCurrentPage} data-id="element-0" />;
      case 'signup':
        return <SignUpPage onNavigate={setCurrentPage} data-id="element-1" />;
      case 'forgot-password':
        return <ForgotPasswordPage onNavigate={setCurrentPage} data-id="element-2" />;
      case 'onboarding':
        return <OnboardingPage onNavigate={setCurrentPage} data-id="element-3" />;
      case 'home':
        return <HomePage onNavigate={handleNavigate} data-id="element-4" />;
      case 'impact':
        return <ImpactPage onNavigate={handleNavigate} data-id="element-5" />;
      case 'actions':
        return <ActivityPage onNavigate={setCurrentPage} actionIdToOpen={selectedActionForCert} onConsumedActionIdToOpen={handleConsumedActionIdToOpen} defaultTab={actionsDefaultTab} previousPage={previousPage} data-id="element-6" />;
      case 'market':
        return <ShopPage onNavigate={setCurrentPage} onOpenRewardDetail={handleOpenRewardDetail} data-id="element-7" />;
      case 'reward-detail':
        return selectedRewardId ? <RewardDetailPage claimedRewardId={selectedRewardId} onNavigate={setCurrentPage} data-id="element-8" /> : <ShopPage onNavigate={setCurrentPage} onOpenRewardDetail={handleOpenRewardDetail} data-id="element-9" />;
      case 'settings':
        return <SettingsPage onNavigate={setCurrentPage} data-id="element-10" />;
      case 'gb-intelligence':
        return <GBIntelligencePage onNavigate={setCurrentPage} data-id="element-11" />;
      case 'activity-detail':
        return selectedActivity ? <ActivityDetailPage activity={selectedActivity} onNavigate={setCurrentPage} onBack={handleBackFromDetail} data-id="element-12" /> : <ImpactPage onNavigate={handleNavigate} data-id="element-13" />;
      default:
        return <HomePage onNavigate={handleNavigate} data-id="element-14" />;
    }
  };
  return <>
      {renderPage()}
      {toast && <Toast message={toast.message} variant={toast.variant} onClose={hideToast} data-id="element-15" />}
    </>;
}
export function App() {
  return <AppProvider data-id="element-16">
      <AppContent data-id="element-17" />
    </AppProvider>;
}